// screens/ContactScreen.jsx
import React from "react";
import Contact from "../components/Contact";

const ContactScreen = () => {
  return (
    <main>
      <Contact />
    </main>
  );
};

export default ContactScreen;